












































import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../../store/index';

export default Vue.extend({
  name: 'CheckResultOneToOne',
  computed: mapState({
    checkInfo: (state: any) => store.getters.getCheckInfo
  }),
  data() {
    return {
    };
  },
  methods: {
    // 初始化检测结果
    initCheckResult() {
      // console.log('检测结果');
    }
  },
  mounted() {
    this.initCheckResult();
  }
});
